import { Link } from "react-router-dom";
import { ArrowUpRight, ArrowRight } from "lucide-react";
import { motion } from "framer-motion";

export const Eyebrow = ({ children, light = false, className = "" }) => (
  <p className={`eyebrow flex items-center gap-3 ${light ? "text-[#9FD3CD]" : "text-[var(--teal-ink)]"} ${className}`}>
    <span className={`inline-block h-2 w-2 rotate-45 border ${light ? "border-[#9FD3CD]" : "border-[var(--teal-ink)]"}`} />
    {children}
  </p>
);

const base = "group relative inline-flex items-center justify-center gap-2 overflow-hidden rounded-full px-6 py-3.5 text-[0.95rem] font-medium transition-[background-color,color,border-color,transform] duration-300 active:scale-[0.98]";
const variants = {
  primary: "bg-[var(--ink)] text-[var(--paper)] hover:bg-[var(--teal-ink)]",
  teal: "bg-[var(--teal)] text-[var(--ink)] hover:bg-[#5cc0b7]",
  ghost: "border border-[var(--ink)]/25 text-[var(--ink)] hover:border-[var(--ink)] hover:bg-[var(--ink)] hover:text-[var(--paper)]",
  light: "border border-white/30 text-white hover:bg-white hover:text-[var(--ink)]",
};

export const Btn = ({ to, href, children, variant = "primary", className = "", icon = "arrow", ...rest }) => {
  const Icon = icon === "up" ? ArrowUpRight : ArrowRight;
  const inner = (
    <>
      <span>{children}</span>
      {icon && <Icon className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />}
    </>
  );
  const cls = `${base} ${variants[variant]} ${className}`;
  if (href) return <a href={href} className={cls} {...rest}>{inner}</a>;
  if (to) return <Link to={to} className={cls} {...rest}>{inner}</Link>;
  return <button className={cls} {...rest}>{inner}</button>;
};

export const ArrowLink = ({ to, children, light = false, ...rest }) => (
  <Link to={to} className={`group inline-flex items-center gap-2 text-sm font-medium ${light ? "text-white" : "text-[var(--ink)]"}`} {...rest}>
    <span className="relative">
      {children}
      <span className={`absolute -bottom-0.5 left-0 h-px w-full origin-left scale-x-100 transition-transform duration-500 group-hover:scale-x-0 ${light ? "bg-white/50" : "bg-[var(--ink)]/30"}`} />
    </span>
    <motion.span className="inline-flex" whileHover={{ x: 3 }}><ArrowUpRight className="h-4 w-4 text-[var(--teal)]" /></motion.span>
  </Link>
);

export const Container = ({ children, className = "" }) => <div className={`mx-auto w-full max-w-[1320px] px-5 sm:px-8 lg:px-12 ${className}`}>{children}</div>;
